import { ApiClientInterface } from './clients';
import { AccountType } from './enums/AccountType';
import { Account, Money, UuidResult } from './models';

function coerceMoney(value: unknown): Money | null {
  if (!value || typeof value !== 'object') {
    return null;
  }

  const money = value as Partial<Money>;
  if (typeof money.amount !== 'number') {
    return null;
  }

  return {
    amount: money.amount,
    currencyCode: typeof money.currencyCode === 'string' ? money.currencyCode : 'RUB',
  };
}

function parseAccount(data: unknown, expectedType: AccountType): Account | null {
  if (data === null || data === undefined || data === '') {
    return null;
  }
  if (typeof data !== 'object') {
    return null;
  }
  const account = data as Partial<Account>;
  if (typeof account.uuid !== 'string' || !account.uuid) {
    return null;
  }
  if (account.type !== expectedType) {
    return null;
  }

  const balance = coerceMoney(account.balance);
  const reservedFunds = coerceMoney(account.reservedFunds);
  const registeredFunds = coerceMoney(account.registeredFunds);

  if (!balance || !reservedFunds || !registeredFunds) {
    return null;
  }

  return {
    uuid: account.uuid,
    type: account.type,
    balance,
    reservedFunds,
    registeredFunds,
  };
}

export class AccountManager {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public getAll(): Promise<Account[]> {
    return this.apiClient.get('/');
  }

  public async getOne(type: AccountType): Promise<Account | null> {
    const data = await this.apiClient.get(`/${type}`);
    return parseAccount(data, type);
  }

  public create(accountType: AccountType): Promise<UuidResult> {
    return this.apiClient.post('/', { accountType });
  }

  public transfer(
    fromAccountType: AccountType,
    toAccountType: AccountType,
    money: Money
  ): Promise<UuidResult> {
    return this.apiClient.post('/transfer', { fromAccountType, toAccountType, money });
  }
}
